import React from 'react';
import styled from '@emotion/styled';

const OverlayWrapper = styled.div`
  position : fixed;
  top : 0;
  left : 0;
  width : 100%;
  height : 100%;
  background : rgba(0,0,0,0.7);
  display : flex;
  justify-content : center;
  align-items : center;
  z-index : 10;
  flex-direction : column;
`;

const Overlay = ({children}) => {
  return(
    <OverlayWrapper>
      {children}
    </OverlayWrapper>
  )
};

export default Overlay;